import React, { useEffect, useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  TextField, MenuItem, Button, Alert, CircularProgress, Typography
} from '@mui/material';
import ApiService from '../../services/api.service';

export const EMPLOYEE_STATUSES = [
  { value: 'ACTIVE', label: 'Active', color: 'success' },
  { value: 'DEACTIVATED', label: 'Deactivated', color: 'error' },
  { value: 'ABSCONDED', label: 'Absconded', color: 'warning' },
  { value: 'LONG_LEAVE', label: 'Long Leave', color: 'info' }
];

const ChangeEmployeeStatusDialog = ({ open, orgId, employee, onClose, onUpdated }) => {
  const [status, setStatus] = useState('ACTIVE');
  const [reason, setReason] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!open) return;
    setStatus(employee?.status || 'ACTIVE');
    setReason(employee?.statusInfo || '');
    setError(null);
  }, [open, employee]);

  const handleSave = async () => {
    setSaving(true);
    setError(null);
    try {
      const resp = await ApiService.updateClientEmployeeStatus(orgId, employee.uid, {
        status,
        status_info: reason.trim() || null
      });
      onUpdated(resp?.data?.data || { ...employee, status, statusInfo: reason.trim() || null });
    } catch (e) {
      setError(e?.response?.data?.message || e?.response?.data?.error || 'Failed to update the status');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onClose={() => !saving && onClose()} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontSize: '0.95rem' }}>Change status</DialogTitle>
      <DialogContent>
        {error && <Alert severity="error" sx={{ mb: 1.5 }}>{error}</Alert>}
        <Typography variant="body2" sx={{ mb: 2, color: 'text.secondary' }}>{employee?.name}</Typography>
        <TextField
          select
          fullWidth
          size="small"
          label="Status"
          value={status}
          onChange={(e) => setStatus(e.target.value)}
          sx={{ mb: 2 }}
        >
          {EMPLOYEE_STATUSES.map((s) => <MenuItem key={s.value} value={s.value}>{s.label}</MenuItem>)}
        </TextField>
        <TextField
          fullWidth
          size="small"
          label="Reason (optional)"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          multiline
          minRows={2}
          inputProps={{ maxLength: 500 }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={saving}>Cancel</Button>
        <Button
          variant="contained"
          onClick={handleSave}
          disabled={saving}
          startIcon={saving ? <CircularProgress size={14} color="inherit" /> : null}
        >
          {saving ? 'Saving…' : 'Save'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ChangeEmployeeStatusDialog;
